
            const data = {"name":"solid/table","data":{"viewBox":"0 0 512 512","data":"<path pid=\"0\" d=\"M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64v-96h160v96zm0-160H64v-96h160v96zm224 160H288v-96h160v96zm0-160H288v-96h160v96z\"/>","originalColors":[],"stopColors":[]}}
        
                    module.exports = data
                    